import { RunnableLambda } from '@langchain/core/runnables';
import { OpenAI } from 'openai';

export const textToSpeech = (text: string, openAi: OpenAI) => {
  return new RunnableLambda({
    func: async () => {
      try {
        const response = await openAi.audio.speech.create({
          model: 'tts-1',
          voice: 'shimmer',
          input: text,
        });

        const buffer = new Uint8Array(await response.arrayBuffer());
        const blob = new Blob([buffer], { type: 'audio/mpeg' });

        return {
          blob,
        };
      } catch (error) {
        console.error('Error generating speech:', error);
        throw error;
      }
    },
  });
};
